import moment from "moment";

export default function useAuth() {
  moment().locale("pt-br");
  return {
    authenticated: true
  };
}
